export type AuthRequirement = 'authenticated' | 'anonymous'

export interface NormalizedAuthRequire {
  /** The requirement to enforce — defaults to the RESTRICTIVE branch. */
  require: AuthRequirement
  /** True only when `raw` was exactly `'authenticated'` or `'anonymous'`. */
  isKnown: boolean
}

/**
 * `scene.set.auth.require` comes verbatim from remote cinematics config.
 * Normalize it to a known value defaulting to `authenticated` (the restrictive
 * branch), so a typo/case drift ("Authenticated", "AUTHENTICATED ") can't
 * silently invert the gate into `anonymous` and expose member-only actors to
 * anonymous visitors. `isKnown` lets the caller report the bad value (once,
 * from an effect) without polluting the render path. See PRO-344 H2.
 */
export const normalizeAuthRequire = (raw: unknown): NormalizedAuthRequire => {
  const isKnown = raw === 'authenticated' || raw === 'anonymous'
  const require: AuthRequirement =
    String(raw ?? '').trim().toLowerCase() === 'anonymous' ? 'anonymous' : 'authenticated'
  return { require, isKnown }
}
